/**
 * 统一日志工具
 * 根据环境自动过滤日志输出
 * 
 * 生产环境: 只输出 error
 * 测试环境: 输出 warn + error
 * 开发环境: 输出所有日志
 */

const env = import.meta.env.VITE_APP_ENV || import.meta.env.NODE_ENV || 'development'

// 日志级别
const LOG_LEVELS = {
  debug: 0,
  info: 1,
  warn: 2,
  error: 3
}

// 不同环境的日志级别配置
const ENV_LOG_LEVEL = {
  development: LOG_LEVELS.debug,  // 开发环境: 所有日志
  test: LOG_LEVELS.warn,          // 测试环境: warn + error
  staging: LOG_LEVELS.warn,       // 预生产: warn + error
  production: LOG_LEVELS.error    // 生产环境: 仅 error
}

const currentLogLevel = ENV_LOG_LEVEL[env] || LOG_LEVELS.warn

/**
 * 格式化日志消息
 */
function formatMessage(level, ...args) {
  const timestamp = new Date().toISOString()
  return [`[${timestamp}] [${level.toUpperCase()}]`, ...args]
}

/**
 * 日志对象
 */
export const logger = {
  debug(...args) {
    if (currentLogLevel <= LOG_LEVELS.debug) {
      console.debug(...formatMessage('debug', ...args))
    }
  },
  
  info(...args) {
    if (currentLogLevel <= LOG_LEVELS.info) {
      console.info(...formatMessage('info', ...args))
    }
  },
  
  warn(...args) {
    if (currentLogLevel <= LOG_LEVELS.warn) {
      console.warn(...formatMessage('warn', ...args))
    }
  },
  
  error(...args) {
    // error 始终输出
    console.error(...formatMessage('error', ...args))
  }
}

/**
 * 生产环境禁用所有 console (可选)
 * 在 main.js 中调用
 */
export function disableConsoleInProduction() {
  if (env === 'production') {
    console.log = () => {}
    console.debug = () => {}
    console.info = () => {}
    console.warn = () => {}
    // error 保留,用于错误追踪
  }
}
